<template>
  <div
    ref="overlayContent"
    class="document-similar-documents d-flex flex-column i-p-10 i-gap-10"
    data-testid="similar-documents-overlay"
  >
    <div class="text d-flex flex-column align-items-start flex-grow-1 i-gap-1">
      <div class="name i-text-heading-6 i-text-neutral-120">
        Similar Documents
      </div>
      <div class="subtitle i-text-body-3 i-text-neutral-110">
        How does this document compare?
      </div>
    </div>

    <!-- document trust score chart -->
    <document-trust-score-chart
      :customer-id="customerId"
      :document="document"
    ></document-trust-score-chart>

    <!-- Similar Documents -->
    <div
      v-if="showSimilarDocuments"
      class="similar-docs-container data-box d-flex flex-column"
    >
      <similar-documents-list :customer-id="customerId" :document="document" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DocumentTrustScoreChart from '@/V2/documents/document-view/DocumentTrustScoreChart';
import SimilarDocumentsList from '@/V2/documents/SimilarDocumentsList';

export default {
  components: { DocumentTrustScoreChart, SimilarDocumentsList },

  props: {
    document: {
      type: Object,
      default: undefined,
    },
    customerId: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    ...mapGetters({
      showSimilarDocuments: 'showSimilarDocuments',
    }),
  },
};
</script>

<style lang="scss" scoped>
.document-similar-documents {
  width: 100%;
  height: 100%;
}
</style>
